module.exports = __webpack_public_path__ + "static/img/77021D_R_02_20170816_fit.2c0bac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77021D_R_02_20170816_fit.png
// module id = 7/e+
// module chunks = 0